<div class="main_content position-relative">
  <section class="common-wrap">
    <div class="our-feature feature-block1 mt-80" id="chatBotAutomation">
      <div class="container-fluid">
        <!-- <div class="main-heading text-center">Our Features</div> -->
        <img loading="lazy" src="../../../assets/images/new/3 process white.jpg" />
        <div class="row align-center">
          <div
            class="col-lg-3 wow bounceInLeft text-md-left text-center"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: bounceInLeft;
            "
          >
            <div class="display-inline">
              <div class="feature-circle">
                <img loading="lazy"
                  src="https://snatchjobs.sg/employer_asset/img/feature-img1.png"
                />
              </div>
              <div class="heading-mid text-center fb-heading">
                Chat bot Automation
              </div>
            </div>
          </div>
          <div
            class="col-lg-9 wow bounceInRight"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: bounceInRight;
            "
          >
            <div class="row">
              <div class="col-md-6">
                <div class="white-box">
                  <div class="display-flex align-center of-flex">
                    <div class="yellow-circle">
                      <img loading="lazy"
                        src="https://snatchjobs.sg/employer_asset/img/feature-icon1.png"
                        alt=""
                      />
                    </div>
                    <div class="heading-mid">
                      Get Real REVIEWS from your Customers
                    </div>
                  </div>
                  <p>
                    The review upgrade allows you to create a QR code URL for
                    your customers to leave you feedbacks in a internal feedback
                    system.
                  </p>
                  <!-- <ul>
                                        <li>Chatbot is available 24/7 as long as there is still an opening.</li><li>Hassle-free as the bot will ask the repeated screening questions.</li><li>Instant interviews with candidates upon application.</li>
                                    </ul> -->
                </div>
              </div>
              <div class="col-md-6">
                <div class="white-box">
                  <div class="display-flex align-center of-flex">
                    <div class="yellow-circle">
                      <img loading="lazy"
                        src="https://snatchjobs.sg/employer_asset/img/feature-icon2.png"
                        alt=""
                      />
                    </div>
                    <div class="heading-mid">
                      Filter only 5 STAR Reviews to go to your desired social
                      media
                    </div>
                  </div>
                  <p>
                    The internal system allows you to list the employees you
                    have or show a general feedback page. In this way you are
                    able to tell which employees are providing good service to
                    your clients and incentivize them correctly.
                  </p>
                  <!-- <ul>
                                        <li>Save time and accelerate the hiring process</li><li>Instant overview of candidates' scores</li><li>Pick the best matching candidates for shortlisting</li>
                                    </ul> -->
                </div>
              </div>
              <div class="col-md-6">
                <div class="white-box">
                  <div class="display-flex align-center of-flex">
                    <div class="yellow-circle">
                      <img loading="lazy"
                        src="https://snatchjobs.sg/employer_asset/img/feature-icon3.png"
                        alt=""
                      />
                    </div>
                    <div class="heading-mid">
                      Reward loyal customers who leave 5 Star reviews on Social
                      Media e.g Google Reviews
                    </div>
                  </div>
                  <p>
                    This is a sure win method to see strong organic growth of
                    your social media. Customers are provided vouchers and they
                    send screenshots of their reviews to a whatsapp of your
                    choosing. Vouchers are manually sent or can be
                    self-collected at your outlet.
                  </p>
                  <!-- <ul>
                                        <li>AI assistant will assist in generating suitable questions</li><li>Have the ability to create and customise questions</li><li>Create scores for multiple-choice questions (MCQs)</li>
                                    </ul> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="our-feature feature-block2" id="fastDirectContact">
      <div class="container-fluid">
        <div class="row align-center">
          <div
            class="col-lg-3 order-2 wow bounceInRight text-md-right text-center"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: bounceInRight;
            "
          >
            <div class="display-inline">
              <div class="feature-circle">
                <img loading="lazy"
                  src="https://snatchjobs.sg/employer_asset/img/feature-img2.png"
                />
              </div>
              <div class="heading-mid text-center fb-heading">
                Fast Direct <br />Contact
              </div>
            </div>
          </div>
          <div
            class="col-lg-9 wow bounceInLeft text-md-left text-center"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: bounceInLeft;
            "
          >
            <div class="row">
              <div class="col-md-12">
                <div class="white-box mnh-300 mb-0">
                  <div class="display-flex align-center of-flex">
                    <div class="yellow-circle">
                      <img loading="lazy"
                        src="https://snatchjobs.sg/employer_asset/img/feature-icon4.png"
                        alt=""
                      />
                    </div>
                    <div class="heading-mid">
                      Advanced Technology for Protection of Spam
                    </div>
                  </div>
                  <p>
                    Each customer is able to leave only 1 review per month. Our
                    system is able to filter out repeat reviews and spam.
                  </p>
                  <!-- <ul>
                                        <li>Can contact you directly</li><li>Speedy process</li><li>Convenience to your preference</li>
                                    </ul> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
